/**
 * connection actions
 */
import { SET_IS_ONLINE } from './constants';

export function setIsOnline(isOnline: boolean): Record<string, any> {
    return {
        type: SET_IS_ONLINE,
        payload: {
            isOnline
        },
        meta: {
            logentries: true
        }
    };
}
